module.exports = __webpack_public_path__ + "img/Rkwm.71ab40d9.gif";